import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import angular, {IPromise} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {Debugger} from 'debug'
import {DokumentsigneringRessurs} from "felles/tjenester/ressurser/DokumentsigneringRessurs";
import {MdDialogController} from "../../../../tjenester/Dialog";
import {DokumentsigneringTjeneste} from "../../../../../felles/tjenester/modulspesifikke/DokumentsigneringTjeneste";

const debug: Debugger = require('debug')('AvsluttSigneringsprosessDialog');
const css = require('./avsluttSigneringsprosessDialog.scss');

export class AvsluttSigneringsprosessDialog implements MdDialogController {

    static visAvsluttSigneringsprosessDialog(dokumentversjon: l.DokumentVersjonModell, $mdDialog: angular.material.IDialogService): IPromise<void> {
        return $mdDialog.show(this.dialogKonfigurasjon({dokumentversjon: dokumentversjon}));
    }

    private static dialogKonfigurasjon(locals: Object): angular.material.IDialogOptions {
        return {
            template: require('./avsluttSigneringsprosessDialog.html'),
            controller: AvsluttSigneringsprosessDialog.forInjisering(),
            controllerAs: '$ctrl',
            bindToController: true,
            locals: locals
        };
    }

    static forInjisering() {
        return [
            regNavn.md.$mdDialog,
            DokumentsigneringRessurs.regNavn,
            DokumentsigneringTjeneste.regNavn,
            AvsluttSigneringsprosessDialog
        ]
    }

    constructor(private $mdDialog: angular.material.IDialogService,
                private dokumentsigneringRessurs: DokumentsigneringRessurs,
                private dokumentsigneringTjeneste: DokumentsigneringTjeneste) {
    }

    dokumentversjon: l.DokumentVersjonModell; //settes via bindings

    modus: 'vis' | 'kvittering' = 'vis';

    private harSignert: l.DokumentSignatarModell[];
    private harIkkeSignert: l.DokumentSignatarModell[];

    signaturtype(signaturtype: l.BenyttetSigneringsmetode) {
        return this.dokumentsigneringTjeneste.signaturtypeI18nNavn(signaturtype);
    }

    markerSomFerdigSignert(){
        return this.dokumentsigneringRessurs.markerSomFerdigSignert(this.dokumentversjon.dokumentId).$promise
            .then(() => {
                this.modus = 'kvittering';
            })
    }
    ferdig(){
        this.$mdDialog.hide(true);
    }

    avbryt() {
        this.$mdDialog.cancel();
    }

    $onInit() {
        this.dokumentsigneringRessurs.signatarer(this.dokumentversjon.dokumentId).$promise
            .then(signatarer => this.initSignatarer(signatarer));
    }

    //hjelpemetoder

    private initSignatarer(signatarer: l.DokumentSignatarerModell){
        this.harSignert = signatarer.signatarer.filter(s => s.harSignert)
        this.harIkkeSignert = signatarer.signatarer.filter(s => !s.harSignert)
    }

}
